export const initialState = {
    loading: false,
    error: null,
    customers:null,
    customerList: null,
    selectedCustomer: null,
}